import I18n from "common/i18n";
import { formatElapsed } from "../hooks/useElapsedTime";

// 経過時間チップ。Score（てにいれたアイテム）の右に並ぶため同系の配色・形状に合わせる。
export const PreviewTimeChip = ({ elapsedMs }: { elapsedMs: number }) => (
  <div className="flex-row-center box-border h-full gap-2 rounded-full bg-[#F4E9E0] pl-4 pr-1">
    <p className="type-text type-sm text-textcolor-black whitespace-nowrap">
      {I18n.t("MSG_BUILDER_PREVIEW_TIME")}
    </p>
    <div className="flex-row-center box-border h-12 gap-1 rounded-full bg-white px-2">
      <span className="material-symbols-outlined type-md text-textcolor-black">timer</span>
      <p className="type-text type-md text-textcolor-black tabular-nums">
        {formatElapsed(elapsedMs)}
      </p>
    </div>
  </div>
);
